import { jsx } from "react/jsx-runtime";
import { F as Flex } from "./Flex-BqkSIn_m.js";
const Container = (props) => {
  return /* @__PURE__ */ jsx(Flex, { width: "100%", ...props, className: `${props.className}`, children: props.children });
};
export {
  Container as C
};
